class Product {
  constructor({name,description,product_id,image,Product_Stocks}) {
    this.name = name;
    this.description = description;
    this.image = image;
    this.id = product_id;
    this.loadStock(Product_Stocks);
  }
  loadStock(stocks) {
    const productStock = stocks.pop(); 
    if(!productStock) return;
    this.price = productStock.price;
    this.stock = productStock.stock;
    this.enabled = productStock.enabled;
    this.stockId = productStock.product_stock_id;
  }
}

module.exports = {
  Product
}